
import Vue from 'vue'

export default Vue.extend({
  name: 'partnerLogo',
  props: {
    baseLogo: {
      required: true
    },
    subLogo: {
      required: true
    }
  }
})
